import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Select, SelectOption, Text, TextField } from '@recargas-dominicanas/core/components';
import type { IBusiness, Nullable } from '@recargas-dominicanas/core/types';
import { emptyToUndefine } from '../../../utils/emptyToUndefine';
import { CustomerApi } from '@recargas-dominicanas/core/adminApi';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { Modal } from '../../../components/modal/modal.component';
import { style } from './add-customer-modal.module.css';

interface Props { 
  open: boolean;
  onClose: () => void;
}

export function AddCustomerModal(props: Props) {

  const { open, onClose } = props;

  const [error, setError] = useState<string>();

  const navigate = useNavigate();

  const form = useForm({
    name: '',
    docNumber: { value: '', optional: true, minLength: { length: 11, error: 'Cédula invalida' } },
    phone: { value: '', phone: true },
    email: { value: '', optional: true, email: true },
    businessName: '',
    businessRnc: { value: '', optional: true },
    businessPhone: { value: '', optional: true, phone: true },
    businessEmail: { value: '', optional: true, email: true },
    businessCity: '',
    businessAddress: '',
    system: '' as Nullable<IBusiness['system']>
  });

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);
    
    try {

      const result = await CustomerApi.create({
        name: form.name.value,
        docNumber: emptyToUndefine(form.docNumber.value),
        phone: emptyToUndefine(form.phone.value),
        email: emptyToUndefine(form.email.value),
        businessName: form.businessName.value,
        businessRnc: emptyToUndefine(form.businessRnc.value),
        businessPhone: emptyToUndefine(form.businessPhone.value),
        businessEmail: emptyToUndefine(form.businessEmail.value),
        businessCity: form.businessCity.value,
        businessAddress: form.businessAddress.value,
        system: form.system.value!
      });

      navigate('/created-customer', { state: result });

    } catch {

      setError('Ocurrio un error al crear el cliente');
    }
  }

  return (
    <Modal
      open={open}
      icon='person_add'
      title='Agregar cliente'
      primaryButton='Guardar'
      error={error}
      style={style.modal}
      onPrimaryClick={handleSave}
      onClose={handleClose}
      onSecondaryClick={handleClose}>
      <Text 
        className={style.customerTitle} 
        text='Datos del cliente'/>
      <div className={style.fieldsContent}>
        <TextField 
          style={style.textField} 
          label='Nombre'
          value={form.name.value}
          error={form.name.error}
          onChange={form.name.onChange}
          onBlur={form.name.onBlur}/>
        <TextField 
          style={style.textField} 
          label='Cédula (opcional)'
          value={form.docNumber.value}
          error={form.docNumber.error}
          onChange={form.docNumber.onChange}
          onBlur={form.docNumber.onBlur}/>
        <TextField 
          style={style.textField} 
          label='Teléfono'
          value={form.phone.value}
          error={form.phone.error}
          onChange={form.phone.onChange}
          onBlur={form.phone.onBlur}/>
        <TextField 
          style={style.textField} 
          label='Correo electrónico (opcional)'
          value={form.email.value}
          error={form.email.error}
          onChange={form.email.onChange}
          onBlur={form.email.onBlur}/> 
      </div>
      <Text 
        className={style.businessTitle} 
        text='Datos del Negocio'/>
      <div className={style.fieldsContent}>
        <TextField 
          style={style.textField} 
          label='Nombre'
          value={form.businessName.value}
          error={form.businessName.error}
          onChange={form.businessName.onChange}
          onBlur={form.businessName.onBlur}/>
        <TextField 
          style={style.textField} 
          label='RNC (opcional)'
          value={form.businessRnc.value}
          error={form.businessRnc.error}
          onChange={form.businessRnc.onChange}
          onBlur={form.businessRnc.onBlur}/>
        <TextField 
          style={style.textField} 
          label='Teléfono (opcional)'
          value={form.businessPhone.value}
          error={form.businessPhone.error}
          onChange={form.businessPhone.onChange}
          onBlur={form.businessPhone.onBlur}/>
        <TextField 
          style={style.textField} 
          label='Correo electrónico (opcional)'
          value={form.businessEmail.value}
          error={form.businessEmail.error}
          onChange={form.businessEmail.onChange}
          onBlur={form.businessEmail.onBlur}/> 
        <TextField 
          style={style.textField} 
          label='Ciudad'
          value={form.businessCity.value}
          error={form.businessCity.error}
          onChange={form.businessCity.onChange}
          onBlur={form.businessCity.onBlur}/>
        <TextField 
          style={style.textField} 
          label='Dirección'
          value={form.businessAddress.value}
          error={form.businessAddress.error}
          onChange={form.businessAddress.onChange}
          onBlur={form.businessAddress.onBlur}/>
        <Select 
          style={style.select} 
          label='Sistema'
          placeholder='Seleccionar sistema'
          value={form.system.value}
          error={form.system.error}
          onChange={(value) => {
            form.system.onChange(value);
            form.system.validate(value);
          }}>
          <SelectOption value='mobile-app' label='Aplicación móvil'>Aplicación móvil</SelectOption>
          <SelectOption value='webapp' label='Aplicación web'>Aplicación web</SelectOption>
          <SelectOption value='unknown' label='Ninguno'>Ninguno</SelectOption>
        </Select>
      </div>
    </Modal>
  );
}
